import { Navigate, Outlet } from "react-router";
import { TrialBanner } from "~/components/billing/trial-banner";
import { OnboardingWizard } from "~/components/onboarding/onboarding-wizard";
import { ClientOnly } from "~/components/ui/client-only";
import { useAuth } from "~/lib/hooks/use-auth";
import { useOnboarding } from "~/lib/hooks/use-onboarding";

export default function AuthenticatedLayout() {
	const { user, loading } = useAuth();
	const {
		data: onboarding,
		loading: onboardingLoading,
		updateStep,
		isOnboardingComplete,
	} = useOnboarding();

	if (loading) {
		return (
			<div className="min-h-screen flex items-center justify-center">
				<div className="loading loading-spinner loading-lg" />
			</div>
		);
	}

	if (!user) {
		return <Navigate to="/login" replace />;
	}

	return (
		<>
			<TrialBanner />
			<Outlet />
			<ClientOnly>
				{!onboardingLoading && !isOnboardingComplete && onboarding && (
					<OnboardingWizard
						initialStep={onboarding.onboardingStep}
						userName={onboarding.name}
						userEmail={user.email ?? ""}
						onUpdateStep={updateStep}
					/>
				)}
			</ClientOnly>
		</>
	);
}
